import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfilePlacementUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.81484 11.37C8.71484 11.36 8.59484 11.36 8.48484 11.37C6.10484 11.29 4.21484 9.34 4.21484 6.94C4.21484 4.49 6.19484 2.5 8.65484 2.5C11.1048 2.5 13.0948 4.49 13.0948 6.94C13.0848 9.34 11.1948 11.29 8.81484 11.37Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.815 15.0725C1.395 16.6925 1.395 19.3325 3.815 20.9425C6.565 22.7825 11.075 22.7825 13.825 20.9425C16.245 19.3225 16.245 16.6825 13.825 15.0725C11.085 13.2425 6.575 13.2425 3.815 15.0725Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 7H18.4813C21.6438 7 22.1623 8.74125 21.9623 10.8763L21.4068 17.8763C21.2513 19.5913 20.718 21 17.7406 21H16.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 7V6.4C17 5.0725 17 4 15 4H14.2",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5001 11C19.6883 12.6689 17.5 13.5 16 13.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgProfilePlacementUser;
